webpackJsonp([39],{

/***/ 1532:
/***/ (function(module, exports) {

MOVE.VIDEOS = function (MOVE) {
    "use strict";

    var init = function init() {};
    MOVE.VIDEOS = {
        init: init
    };
    return MOVE.VIDEOS;
}(MOVE || {});

/***/ }),

/***/ 1650:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__application_critical__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_videos_videos__ = __webpack_require__(1532);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_videos_videos___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_videos_videos__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_app___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_app__);




/***/ }),

/***/ 18:
/***/ (function(module, exports) {

(function () {

    //bootstrap application
    MOVE.init();
})();

/***/ })

},[1650]);


// WEBPACK FOOTER //
// videos_critical-7cba2add50e2187a0275.js